import { Attrs, MinzeElement, Reactive } from 'minze'
import { Font } from '../../../constants'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'

Locale.getInstance().registerKeySet('fr', 'LvcAuthLayout', {
  proSignupButton: {
    title: 'Vous êtes un professionnel de la culture ?',
    url: "S'inscrire ici",
  },
})
Locale.getInstance().registerKeySet('en', 'LvcAuthLayout', {
  proSignupButton: {
    title: 'Are you a culture professional?',
    url: 'Sign up here',
  },
})

interface MenuItem {
  title: string
  description: string
  url: string
  icon: string
  proFeature: boolean
}

export interface LvcAuthLayout {
  menuItems: Array<MenuItem>
  isPartner: boolean
  showBecomePartnerButton: boolean
}

export class LvcAuthLayout extends MinzeElement {
  _authHandler: any = null

  attrs: Attrs = ['is-in-b2b-app']

  reactive: Reactive = [
    ['menuItems', []],
    ['isPartner', false],
    ['showBecomePartnerButton', true],
  ]

  handleAuthChanged = async (data: any): Promise<void> => {
    const mainModule = MainModule.getInstance()
    const isPartner = await mainModule.getAuth().isPartner()
    const isPartnerInProcess = await mainModule.getAuth().isPartnerInProcess()
    this.isPartner = isPartner

    if (data?.isLoggedIn && (isPartner || isPartnerInProcess)) {
      this.showBecomePartnerButton = false
    }
  }

  async onReady(): Promise<void> {
    const mainModule = MainModule.getInstance()
    const lang = mainModule.getLang()

    this._authHandler = this.handleAuthChanged.bind(this)
    mainModule.getEE().on('lvc:user_state_changed', this._authHandler.bind(this))
    this.handleAuthChanged({
      isLoggedIn: await mainModule.getAuth().isLoggedIn(),
    })
  }

  html = () => `
    <div class="auth-layout padding-global">
      <a href="/" class="logo-lvc">
        <img src="https://cdn.prod.website-files.com/66c490b4d6816add107c6ec9/66c490b4d6816add107c6ed9_logo.svg" loading="lazy" width="141" height="90" alt="" class="nav_logo">
      </a>
      <div class="auth-container">
        ${
          this.isInB2bApp
            ? ''
            : `
        <div class="auth-menu-box">
          <lvc-hand-drawn-box bgColor="transparent">
            <div class="auth-menu">
              <slot name="auth-menu"></slot>
            </div>
            <div class="icon-slot-container">
              <slot name="icon"></slot>
            </div>
          </lvc-hand-drawn-box>
          <div class="auth-pro-menu">
            <p>${Locale.getKey('LvcAuthLayout.proSignupButton.title')}</p>
            <a class="pro-link" href="${MainModule.getInstance().getRouting().getRoute('partnerRegister')}"  target='_blank'>${Locale.getKey('LvcAuthLayout.proSignupButton.url')}</a>
          </div>
        </div>
        `
        }
        <div class="auth-form">
          <slot name="auth-form">
            <slot name="auth-toggle" class="auth-toggle"></slot>
          </slot>
        </div>
      </div>
        <slot name="footer-icon" class="footer-icon"></slot>
        <slot name="footer-icon-mobile"></slot>
    </div>
    
  `

  css = () => `
     :host {
      position: relative;
      background: ${this.background ? this.background : 'linear-gradient(to top left, #f3fdaa, rgba(255, 153, 150, 0), #00aebf), linear-gradient(to top right, #fdecd8,rgba(255, 153, 150, 0), #1ade96) rgba(193,254,175,100);'};
      overflow: hidden;
      min-height: calc(100vh - 89.59px);
      padding-top: 2rem;
      padding-bottom: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 16px;
    }
    .auth-layout {
      max-width: ${this.isInB2bApp ? '40rem' : '80rem'};
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      font-size: 16px;
    }
    .padding-global {
      padding-left: 6rem;
      padding-right: 6rem;
    }
    @media screen and (max-width: 991px) {
      .padding-global {
        padding-left: 4.5rem;
        padding-right: 4.5rem;
      }
    }
    @media screen and (max-width: 767px) {
      .padding-global {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
    .auth-toggle {
      display: none;
    }

    .logo-lvc {
      display:none;
    }

    .icon-slot-container {
      position: absolute;
      top: 0;
      right: 0;
    }

    .footer-icon {
      position: absolute;
      bottom: -60px;
      right: 40px;
    }

    .auth-container {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 4rem;
    }

    .auth-pro-menu {
      display: none; /* Hide for now, will be shown later after pro space is ready */
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      font-family: inherit;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
    }


    .pro-link:hover {
      color: #826acc;
    }

  
    .auth-menu-box {
      max-width: 440px;
    }

    .auth-menu {
      max-width: 550px;
      min-width: 400px;
      min-height: 580px;
      padding: 4rem;
    }

    .auth-form {
      display: flex;
      flex-grow: 1;
      width: 100%;
      flex-direction: column;
      gap: 2rem;
      text-align: center;
      
    }

    .auth-menu-box, .auth-form {
      color: #1E007D;
      font-family: inherit;
    }

    .footer-icon-mobile {
      display: none; /* Hide by default */
    }

    @media only screen and (max-width: 991px) {

      :host {
        background: ${this.background ? this.background : 'linear-gradient(to top, #f3fdaa, rgba(255, 153, 150, 0), #00aebf), linear-gradient(to top, #fdecd8, rgba(255, 153, 150, 0), #1ade96) rgba(193,254,175,100);'};
      }

      lvc-hand-drawn-box {
        display: none;
      }

      .auth-container {
        max-width: 100%;
        flex-direction: column;
        gap: 0;
        padding: 2rem 2rem 0rem 2rem;
      }

      .auth-form {
        max-width: 100%;
      }

      .auth-pro-menu {
        display: none;
      }

      .auth-menu-box {
        width: 100%;
      }

      .auth-menu {
        width: 100%;
        padding: 2rem;
      }
      .footer-icon-mobile {
        margin-top: 2rem;
        display: flex;
        position: absolute;
        bottom: 0;
      }
      .logo-lvc {
        display:block;
      }

      .auth-toggle {
        display: block;
      }

    }
  `
}
